/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentChangelogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentChangelogQuery = { agentChangelog: { __typename: 'AgentChangelogResult', currentVersion: string, releases: Array<{ __typename: 'AgentChangelogRelease', id: string, version: string, releasedOn: any, items: Array<string> }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const AgentChangelogDocument = gql`
    query AgentChangelog {
  agentChangelog {
    __typename
    ... on AgentChangelogResult {
      currentVersion
      releases {
        id
        version
        releasedOn
        items
      }
    }
  }
}
    `;

/**
 * __useAgentChangelogQuery__
 *
 * To run a query within a React component, call `useAgentChangelogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentChangelogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentChangelogQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentChangelogQuery(baseOptions?: Apollo.QueryHookOptions<AgentChangelogQuery, AgentChangelogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentChangelogQuery, AgentChangelogQueryVariables>(AgentChangelogDocument, options);
      }
export function useAgentChangelogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentChangelogQuery, AgentChangelogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentChangelogQuery, AgentChangelogQueryVariables>(AgentChangelogDocument, options);
        }
export function useAgentChangelogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentChangelogQuery, AgentChangelogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentChangelogQuery, AgentChangelogQueryVariables>(AgentChangelogDocument, options);
        }
export type AgentChangelogQueryHookResult = ReturnType<typeof useAgentChangelogQuery>;
export type AgentChangelogLazyQueryHookResult = ReturnType<typeof useAgentChangelogLazyQuery>;
export type AgentChangelogSuspenseQueryHookResult = ReturnType<typeof useAgentChangelogSuspenseQuery>;
export type AgentChangelogQueryResult = Apollo.QueryResult<AgentChangelogQuery, AgentChangelogQueryVariables>;